import { poUploadJobIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const uploadPurchaseOrders = {
  name: "uploadPurchaseOrders" as const,
  input: z.object({}),
  output: z.object({ jobId: poUploadJobIdFormat.schema }),
};
